import { consts } from "@/consts";
import { declineNouns } from "@/mixins/declineNouns";

export const formatDateTime = {
    mixins: [declineNouns],
    props: {
        i18n: Object,
    },
    data() {
        return {
            // months: consts.months,
            // shortMonths: consts.shortMonths
            shortMonths: [
                this.$t("shortMonths.jan"),
                this.$t("shortMonths.feb"),
                this.$t("shortMonths.mar"),
                this.$t("shortMonths.apr"),
                this.$t("shortMonths.may"),
                this.$t("shortMonths.jun"),
                this.$t("shortMonths.jul"),
                this.$t("shortMonths.aug"),
                this.$t("shortMonths.sep"),
                this.$t("shortMonths.oct"),
                this.$t("shortMonths.nov"),
                this.$t("shortMonths.dec"),
            ],
            months: [
                this.$t("months.january"),
                this.$t("months.february"),
                this.$t("months.march"),
                this.$t("months.april"),
                this.$t("months.may"),
                this.$t("months.june"),
                this.$t("months.july"),
                this.$t("months.august"),
                this.$t("months.september"),
                this.$t("months.october"),
                this.$t("months.november"),
                this.$t("months.december"),
            ],
        };
    },
    methods: {
        getDMY(date) {
            let dmy = new Date(date);
            let today = new Date();
            if (dmy.getFullYear() == today.getFullYear()) {
                return (
                    this.addZero(dmy.getDate()) +
                    " " +
                    this.months[dmy.getMonth()]
                );
            } else {
                return (
                    this.addZero(dmy.getDate()) +
                    " " +
                    this.months[dmy.getMonth()] +
                    " " +
                    dmy.getFullYear()
                );
            }
        },
        getShortDMY(date) {
            let dmy = new Date(date);
            let today = new Date();
            if (dmy.getFullYear() == today.getFullYear()) {
                return (
                    this.addZero(dmy.getDate()) +
                    " " +
                    this.shortMonths[dmy.getMonth()]
                );
            } else {
                return (
                    this.addZero(dmy.getDate()) +
                    " " +
                    this.shortMonths[dmy.getMonth()] +
                    " " +
                    dmy.getFullYear()
                );
            }
        },
        getVerbalDay(date) {
            let today = new Date();
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            if (this.getDMY(date) == this.getDMY(today)) {
                return this.$t("vipbuy.today");
            } else if (this.getDMY(date) == this.getDMY(yesterday)) {
                return this.$t("vipbuy.yesterday");
            }
            return this.getDMY(date);
        },
        getLastMessageTime(date) {
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            if (this.getDMY(date) == this.getDMY(new Date())) {
                return this.getVerbalDate(date);
            } else if (this.getDMY(date) == this.getDMY(yesterday)) {
                return this.$t("vipbuy.yesterday");
            }
            return this.getDMY(date);
        },
        getVerbalDate(date) {
            let today = new Date();
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            let delta = +new Date() - date;
            if (delta >= 2 * 3600 * 1000) {
                let dm;
                if (this.getDMY(date) == this.getDMY(today)) {
                    dm = this.$t("vipbuy.today");
                } else if (this.getDMY(date) == this.getDMY(yesterday)) {
                    dm = this.$t("vipbuy.yesterday");
                } else {
                    dm = this.getDMY(date);
                }
                // return dm + " в " + this.getHM(date);
                return `${dm} ${this.$t("profile.in")} ${this.getHM(date)}`;
            } else {
                return (
                    this.getRemainHM(delta / 1000, "") +
                    this.$t("vipbuy.backward")
                );
            }
        },
        getHM(date) {
            let hm = new Date(date);
            return (
                this.addZero(hm.getHours()) +
                ":" +
                this.addZero(hm.getMinutes())
            );
        },
        getMS(date) {
            let ms = new Date(date);
            return (
                this.addZero(ms.getMinutes()) +
                ":" +
                this.addZero(ms.getSeconds())
            );
        },
        addZero(number) {
            return number.toString().length == 1 ? "0" + number : number;
        },
        getRemainHM(time, nominativeCase = false) {
            let hours = Math.floor(time / 3600);
            let minutes = Math.floor((time % 3600) / 60);
            let dateText = "";
            if (hours > 0) {
                dateText =
                    hours +
                    " " +
                    this.declineNouns(hours, [
                        this.$t("vipbuy.hour"),
                        this.$t("vipbuy.hoursa"),
                        this.$t("vipbuy.hours"),
                    ]) +
                    " ";
            }
            if (minutes > 0) {
                let minText = nominativeCase
                    ? this.$t("vipbuy.minute")
                    : this.$t("vipbuy.minutely");
                dateText +=
                    minutes +
                    " " +
                    this.declineNouns(minutes, [
                        minText,
                        this.$t("vipbuy.minutes"),
                        this.$t("vipbuy.minutae"),
                    ]);
                return dateText;
            } else {
                return this.$t("vipbuy.lessMinute");
            }
        },
    },
};
